
import styled from "styled-components";

const StyledNav = styled.div`
    padding: 4rem 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    svg {
      font-size: 2rem;
    }
`;

export default StyledNav;
